var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.is_loaded('init_fetch'))?_c('div',[_c('div',{staticClass:"rates_grid row"},_vm._l((_vm.symbols_to_show),function(elem){return _c('GridItem',{key:elem.symbol_id,attrs:{"elem":elem,"open_new_tab":true}})}),1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }